import {Helmet} from 'react-helmet';

import {headTitle} from 'shells/document/head-title';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';

import {ExpiredPageContent} from './expired-page-content';
import {PreAuthIllustratedLayout} from './pre-auth-illustrated-layout';

import styles from './expired-page.module.css';
import layoutStyles from './pre-auth-illustrated-layout.module.css';

export function ExpiredPage() {
    return (
        <>
            <Helmet>
                <title>{headTitle('Trial expired')}</title>
            </Helmet>
            <PreAuthIllustratedLayout
                showDesktopIllustrationFooter={false}
                centerIllustration={true}
                rightPaneBackground={
                    <img src='/include/images/auth/expired-trial-background.svg' alt='' />
                }
                illustration={
                    <Stack
                        spacing={0}
                        alignItems='center'
                        justifyContent='center'
                        isFullWidth={true}
                        isFullHeight={true}
                    >
                        <img
                            src='/include/images/auth/expired-trial-hourglass.svg'
                            alt=''
                            className={styles['hourglass']}
                        />
                    </Stack>
                }
            >
                <div className={`${layoutStyles['left-header']} pt-24`}>
                    <Link href='https://www.nutshell.com/home'>
                        <img
                            src='/include/images/nutshell-logo-full-color.svg'
                            alt='Nutshell'
                            className={styles['logo']}
                        />
                    </Link>
                </div>
                <div className={layoutStyles['left-main']}>
                    <ExpiredPageContent />
                </div>
            </PreAuthIllustratedLayout>
        </>
    );
}
